import './init/logger'
import { authService } from './init/auth'
import { buildRootRouter, registerVuetify, registerToastify, vueCreateApp } from '@prodcard/apps-vue'
import { usersService, controlQuestionsService } from './init/users'
import { rolesService } from './init/roles'
import { citizensService } from './init/citizens'
import { selfRegistrationService } from './init/selfRegistration'
import { cardIssuePointsService } from './init/cardIssuePoint'
import { identityCardsService } from './init/identityCards'
import { municipalEntitiesService } from './init/municipalEntities'
import { bgOperationsService } from './init/bgOperations'
import { appSettingsService } from './init/appSettings'
import { salesPointsService } from './init/salesPoints'

import App from './App.vue'
import { actualIssueProductsService } from './init/actualIssueProducts'
import { globalSettingsService } from './init/globalSettings'
import { consumptionStandardsService } from './init/consumptionStandards'
import { productPlansService } from './init/productPlans'
import { consumptionRatesService } from './init/consumptionRates'
import { citizenCategoriesCoefficientsService } from './init/citizenCategoriesCoefficients'
import { translationService } from './init/translation'
import { usedCardsStatsService } from './init/usedCardsStats'
import { toolsService } from './init/tools'
import { issuanceCardsStatsService } from './init/issuanceCardsStats'
import { addressSuggesterService } from './init/suggester'

const app = vueCreateApp(App, { authService, bgOperationsService })
app.use(
  buildRootRouter({
    authService,
    usersService,
    rolesService,
    cardIssuePointsService,
    salesPointsService,
    citizensService,
    selfRegistrationService,
    controlQuestionsService,
    identityCardsService,
    municipalEntitiesService,
    bgOperationsService,
    appSettingsService,
    actualIssueProductsService,
    globalSettingsService,
    consumptionStandardsService,
    consumptionRatesService,
    productPlansService,
    issuanceCardsStatsService,
    usedCardsStatsService,
    citizenCategoriesCoefficientsService,
    translationService,
    toolsService,
    addressSuggesterService,
  }),
)
registerVuetify(app)
registerToastify(app)
app.mount('#app')
